import React from "react";
import useTranslator from "../../hooks/useTranslator";

const AggregationStrategySelector = ({ value = "MIN", onChange }) => {
  const { _t } = useTranslator();

  return (
    <label className="aggregation-strategy-selector">
      <span>{_t("aggregationStrategy", "Score aggregation")}</span>
      <select value={value} onChange={(event) => onChange(event.target.value)}>
        <option value="MIN">{_t("minimum", "Minimum")}</option>
        <option value="MAX">{_t("maximum", "Maximum")}</option>
        <option value="MEAN">{_t("mean", "Mean")}</option>
      </select>
    </label>
  );
};

export default AggregationStrategySelector;
